import React from 'react';
import UsFlag from '../../../svgs/heart/circleFlags/Us';
import EuFlag from '../../../svgs/heart/circleFlags/Eu';
import GbFlag from '../../../svgs/heart/circleFlags/Gb';
import CaFlag from '../../../svgs/heart/circleFlags/Ca';
import AuFlag from '../../../svgs/heart/circleFlags/Au';
import NzFlag from '../../../svgs/heart/circleFlags/Nz';
import BrFlag from '../../../svgs/heart/circleFlags/Br';
import ChFlag from '../../../svgs/heart/circleFlags/Ch';
import SeFlag from '../../../svgs/heart/circleFlags/Se';
import NoFlag from '../../../svgs/heart/circleFlags/No';
import DkFlag from '../../../svgs/heart/circleFlags/Dk';
import InFlag from '../../../svgs/heart/circleFlags/In';
import MxFlag from '../../../svgs/heart/circleFlags/Mx';
import PhFlag from '../../../svgs/heart/circleFlags/Ph';
import CoFlag from '../../../svgs/heart/circleFlags/Co';
import DoFlag from '../../../svgs/heart/circleFlags/Do';
import AlFlag from '../../../svgs/heart/circleFlags/Al';
import BdFlag from '../../../svgs/heart/circleFlags/Bd';
import UaeFlag from '../../../svgs/heart/circleFlags/Uae';
import * as Styled from './CurrencyTag.styled';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/*
 * ISO 4217 currency code → local flag component mapping.
 * Only currencies with an available flag are mapped; others render null.
 */
const CURRENCY_CODE_TO_FLAG = {
  USD: UsFlag,
  EUR: EuFlag,
  GBP: GbFlag,
  CAD: CaFlag,
  AUD: AuFlag,
  NZD: NzFlag,
  BRL: BrFlag,
  CHF: ChFlag,
  SEK: SeFlag,
  NOK: NoFlag,
  DKK: DkFlag,
  INR: InFlag,
  MXN: MxFlag,
  PHP: PhFlag,
  COP: CoFlag,
  DOP: DoFlag,
  ALL: AlFlag,
  BDT: BdFlag,
  AED: UaeFlag
};
const getCurrencyFlag = code => {
  const Flag = code ? CURRENCY_CODE_TO_FLAG[code.toUpperCase()] : undefined;
  return Flag ? /*#__PURE__*/_jsx(Flag, {
    width: 16,
    height: 16,
    "aria-hidden": "true"
  }) : null;
};

/**
 * Visual currency tag that overlays the divider line beneath the Other Amount input.
 * Internal-only: used by Donation OtherAmount when variant === 'six_grid_layout'.
 */
export const CurrencyTag = ({
  code
}) => /*#__PURE__*/_jsxs(Styled.Container, {
  "aria-hidden": "true",
  children: [getCurrencyFlag(code), /*#__PURE__*/_jsx("span", {
    children: code
  })]
});